export default "__VITE_ASSET__BtMv5y7C__"